import React from "react";
import getPhoneType from "../helpers/PhoneTypes";
import styles from "./PhoneDetails.module.scss";

function PhoneDetails({ number, type, ext }) {
  return (
    <>
      {!ext ? (
        <>
          <span className={styles.type}>{getPhoneType(type)}</span>
          <span className={styles.number}>{number}</span>
        </>
      ) : (
        <>
          <span className={styles.type}>{getPhoneType(type)}</span>
          <span className={styles.number}>
            {number}x{ext}
          </span>
        </>
      )}
    </>
  );
}

export default PhoneDetails;
